import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-regular-arrow-right",
  "use": "fi-icon-regular-arrow-right-usage",
  "viewBox": "0 0 5.929 10.456",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5.929 10.456\" id=\"fi-icon-regular-arrow-right\">\n  <path id=\"fi-icon-regular-arrow-right_Path_91279\" data-name=\"Path 91279\" d=\"M0-2.227a.7.7,0,0,0,1.2.5L5.724-6.253a.7.7,0,0,0,0-.994L1.2-11.77a.7.7,0,0,0-1.2.5Z\" transform=\"translate(0 11.978)\" fill=\"#646469\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol